import React from 'react';
import { useAuth } from './context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

function ProtectedRoute() {
    // Obtenemos la información del usuario de nuestro contexto
    const { user } = useAuth();

    // Si no hay un usuario logueado...
    if (!user) {
        // ...redirigimos a la página de login.
        return <Navigate to="/login" />;
    }

    // Si hay un usuario, mostramos la página que se intentaba visitar.
    // <Outlet /> es el marcador de posición para la página hija (en nuestro caso, el Dashboard).
    return <Outlet />;
}

export default ProtectedRoute;